import { createReducer } from '@reduxjs/toolkit';
import {
  setCompaniesWithExceptionsAction,
  setLoadingWageIndexationAction,
  setPreviewAffactedCompaniesAction,
  setWageIndexationDataAction,
  setWageIndexationPreviewAction,
} from 'store/actions/wage-indexation-actions';
import IWageIndexationState from 'types/wage-indexation/IWageIndexationState';

const initialState: IWageIndexationState = {
  loading: false,
  wageIndexation: [],
  wageIndexationPreview: [],
  affectedCompanies: [],
  companiesWithExceptions: [],
};

const wageIndexationReducer = createReducer(initialState, builder => {
  builder
    .addCase(setLoadingWageIndexationAction, (state, action) => ({
      ...state,
      loading: action.payload,
    }))
    .addCase(setWageIndexationDataAction, (state, action) => ({
      ...state,
      wageIndexation: action.payload,
    }))
    .addCase(setWageIndexationPreviewAction, (state, action) => ({
      ...state,
      wageIndexationPreview: action.payload,
    }))
    .addCase(setPreviewAffactedCompaniesAction, (state, action) => ({
      ...state,
      affectedCompanies: action.payload,
    }))
    .addCase(setCompaniesWithExceptionsAction, (state, action) => ({
      ...state,
      companiesWithExceptions: action.payload,
    }));
});

export default wageIndexationReducer;
